module.exports = __webpack_public_path__ + "img/CubeCell Capsule Product Structure.49befa0b.jpg";